import { RefuseLeadsType } from "types/enums";
import { z } from "zod";

export const schema = z
    .object({
        form_structures: z.array(z.string().min(1)),
        form_designs: z.array(z.string().min(1)),
        refuse_leads_active: z.boolean().optional(),
        refuse_leads_types: z.array(z.nativeEnum(RefuseLeadsType)).optional(),
        included_user_ids: z.array(z.string()).optional(),
        excluded_user_ids: z.array(z.string()).optional(),
        process_refuse_leads_active: z.boolean().optional(),
        process_refuse_leads_types: z.array(z.nativeEnum(RefuseLeadsType)).optional(),
        process_included_user_ids: z.array(z.string()).optional(),
        process_excluded_user_ids: z.array(z.string()).optional(),
        iframe_form_prefill: z.boolean().optional(),
        iframe_affiliate_id_rewrite: z.boolean().optional(),
        iframe_auto_submit: z.boolean().optional(),
        external_final_page_active: z.boolean().optional(),
        external_final_page_default_url: z
            .union([z.string().url("forms.general-validation.link_valid_url"), z.literal(""), z.null()])
            .optional(),
        external_final_page_included_user_ids: z.array(z.string()).optional(),
        external_final_page_excluded_default_final_page_user_ids: z.array(z.string()).optional(),
        external_final_page_skip_internal_loader: z.boolean().optional(),
        external_final_page_include_results_in_redirect: z.boolean().optional(),
    })
    .refine(
        (data) => {
            // If refuse_leads_active is true, refuse_leads_types must be provided with at least one item
            if (data.refuse_leads_active === true) {
                return data.refuse_leads_types !== undefined && data.refuse_leads_types.length > 0;
            }
            return true;
        },
        {
            message: "forms.general-validation.refuse_leads_type_required",
            path: ["refuse_leads_types"],
        }
    )
    .refine(
        (data) => {
            // If refuse_leads_types is set, refuse_leads_active must be provided
            if (data.refuse_leads_types !== undefined && data.refuse_leads_types.length > 0) {
                return data.refuse_leads_active !== undefined && data.refuse_leads_active !== null;
            }
            return true;
        },
        {
            message: "forms.general-validation.refuse_leads_active_required",
            path: ["refuse_leads_active"],
        }
    )
    .refine(
        (data) => {
            // If process_refuse_leads_active is true, process_refuse_leads_types must be provided with at least one item
            if (data.process_refuse_leads_active === true) {
                return data.process_refuse_leads_types !== undefined && data.process_refuse_leads_types.length > 0;
            }
            return true;
        },
        {
            message: "forms.general-validation.process_refuse_leads_type_required",
            path: ["process_refuse_leads_types"],
        }
    )
    .refine(
        (data) => {
            // If process_refuse_leads_types is set, process_refuse_leads_active must be provided
            if (data.process_refuse_leads_types !== undefined && data.process_refuse_leads_types.length > 0) {
                return data.process_refuse_leads_active !== undefined && data.process_refuse_leads_active !== null;
            }
            return true;
        },
        {
            message: "forms.general-validation.process_refuse_leads_active_required",
            path: ["process_refuse_leads_active"],
        }
    );

export type OfferApiFormEditFormData = z.infer<typeof schema>;
